// frontend/src/components/LazyFallback.jsx
//
// What shows while a lazily-loaded page chunk is downloading.
//
// It renders NOTHING for the first 200ms, then a spinner.
//
// That delay is the whole point. Chunks served from the same origin usually
// arrive in tens of milliseconds, and a spinner that appears and vanishes in
// that time reads as a flicker — a screen that used to appear instantly would
// suddenly blink on every navigation. Waiting 200ms means the common case looks
// exactly as it did before code splitting, while a genuinely slow load (first
// visit, poor connection) still gets feedback instead of a blank panel.
//
// minHeight matches the space the page would occupy, so nothing below it jumps
// when the real content arrives.
import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LazyFallback({ delayMs = 200 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);

  return (
    <Box
      sx={{
        minHeight: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {show && <CircularProgress size={32} />}
    </Box>
  );
}
